import * as model from "./model.js";
import recipeView from "./views/recipeView.js";
import searchView from "./views/searchView.js";
import resultsView from "./views/resultsView.js";
import paginationView from "./views/paginationView.js";
import bookmarksView from "./views/bookmarksView.js";
import addRecipeView from "./views/addRecipeView.js";
import { MODAL_CLOSE_SECONDS } from "./config.js";

// https://forkify-api.herokuapp.com/v2

///////////////////////////////////////

//this function gets the hash and calls loadRecipe in model which builds the API URL + hash (id variable passed into loadRecipe)
const controlRecipes = async function () {
  try {
    const id = location.hash.slice(1);
    if (!id) return;
    recipeView.renderSpinner();

    resultsView.update(model.getSearchResultsPage());
    // next, we call render spinner from recipeView, which creates the markup, injects it in the DOM in a given element and returns "this (recipeView)" to make it chainable
    bookmarksView.update(model.state.bookmarks);
    await model.loadRecipe(id);
    //loading recipe

    recipeView.render(model.state.recipe); //render generates markup and renders the argument passed into it
  } catch (error) {
    throw error;
  }
};

//publisher-suscriber pattern (passing in controlRecipes to recipeViews instead of importing controlRecipes into recipeViews)

const controlSearchResults = async function () {
  try {
    // 1) Get search query
    //this function returns a the user unput so it can be used as query
    const query = searchView.getQuery();
    if (!query) return;

    // 2) Load search results
    //loadSearchResults is similar to loadRecipe, with the difference that
    //it works by receiving a search query (search query) as argument instead
    //of an id.  This builds a string that is "API URL?search = ${query}", it
    // fetches this string, loops over the results with .map which returns an array of objects
    //provided by the API search results and inserts it into state.search.result

    //loadSearchResult pushes all the search results into state.search.results
    resultsView.renderSpinner();
    await model.loadSearchResults(query);

    //3) Render results

    resultsView.render(model.getSearchResultsPage());

    // 4) render initial pagination buttons
    paginationView.render(model.state.search);
  } catch (error) {
    throw error;
  }
};

// controllers are event handlers
const controlPagination = function (goToPage) {
  // goToPage is received from paginationView.js

  // render new results
  resultsView.render(model.getSearchResultsPage(goToPage));

  // render new pagination buttons
  paginationView.render(model.state.search);
};

const controllServings = function (newServings) {
  // update recipe servings (in state)
  model.updateServings(newServings); //updates model.state.recipe
  // recipeView.render(model.state.recipe);

  // update recipe view

  recipeView.update(model.state.recipe); // this method controlls the recipe servings by updates text on the DOM,
};

const controlAddOrRemoveBookmarks = function () {
  // 1) Add or remove bookmarks
  if (!model.state.recipe.bookmarked) model.addBookmark(model.state);
  else if (model.state.recipe.bookmarked)
    model.deleteBookmark(model.state.recipe.id);

  // 2) updte Recipe container
  recipeView.update(model.state.recipe);

  // 3) render bookmarks
  bookmarksView.render(model.state.bookmarks);
};

const controlLoadSavedBookmarks = function () {
  const savedBookmarks = model.getBookmarks();
  bookmarksView.render(savedBookmarks);
};

const controlAddRecipe = async function (newRecipe) {
  try {
    // Render spinner
    addRecipeView.renderSpinner();

    //upload new recipe data
    await model.uploadRecipe(newRecipe);
    //addRecipeView  gets input from form, calls this function by passing in the input, then passes the input to model.uploadRecipe

    // Render recipe
    recipeView.render(model.state.recipe);

    // Render bookmarks View
    bookmarksView.render(model.state.bookmarks);

    // Render success message on upload
    addRecipeView.renderMessage();

    // Change ID in the URL

    window.history.pushState(null, "", `#${model.state.recipe.id}`);

    // Close form window

    setTimeout(() => {
      addRecipeView.toggleWindow();
    }, MODAL_CLOSE_SECONDS * 1000);
  } catch (error) {
    addRecipeView.renderError(error);
    console.log(error);
  }
};

const init = function () {
  //we pass controlRecipes and controlSearchResults functions into recipeView and search view using the publisher-subscriber pattern.
  // These functions will be called by an event handler in its view module.
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controllServings);
  recipeView.addHandlerBookmark(controlAddOrRemoveBookmarks);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  bookmarksView.addHandlerLoadSavedBookmarks(controlLoadSavedBookmarks);
  addRecipeView.addHandlerUpload(controlAddRecipe);
};

init();
